import { isEntity, PropertyConverter, isEntityType } from '@cognitoforms/model.js';
import type { Property, Entity } from '@cognitoforms/model.js';
import { FORM_ENTRY_TYPE_NAME } from 'src/framework/forms-model';
import { isFormEntry } from '../../core';

/**
 * Even though we generate rules to ensure the back references are set when entities
 * are initialized, we need this converter to prevent default value rules from being
 * triggered during the initialization of existing entries.
 */
export default class InitializeBackReferencesConverter extends PropertyConverter {
	shouldConvert(context: Entity, prop: Property): boolean {
		const contextType = context?.meta?.type;
		if (!contextType)
			return false;

		const formProp = contextType.getProperty('Form');
		const contextIsContainer = contextType.baseType?.fullName === FORM_ENTRY_TYPE_NAME
			|| (formProp && isEntityType(formProp.propertyType)
				&& (formProp.propertyType as any).meta?.baseType?.fullName === FORM_ENTRY_TYPE_NAME);

		return !!contextIsContainer
			&& prop.name !== 'ParentSection' && prop.name !== 'Form'
			&& isEntityType(prop.propertyType)
			&& (!!prop.propertyType.meta.getProperty('ParentSection') || !!prop.propertyType.meta.getProperty('Form'));
	}

	deserialize(context: Entity, value: any, prop: Property) {
		const type = isEntityType(prop.propertyType) && prop.propertyType.meta;
		if (value) {
			if (Array.isArray(value))
				value = value.map(item => this.deserialize(context, item, prop));
			else {
				// avoid modifying the provided object
				if (!isEntity(value))
					value = Object.assign({}, value);

				// If a ParentSection property exists, set it unless...
				// 1. The property's back-reference is "Form" (i.e. top-level address field with a back-reference defined), or...
				// 2. The context is a FormEntry entity (i.e. top-level address field that _doesn't_ have a back-reference defined)
				if (type.getProperty('ParentSection') && prop.backReference?.name !== 'Form' && !(context && isFormEntry(context)))
					value.ParentSection = context;

				if (type.getProperty('Form'))
					value.Form = context.meta.type.baseType.fullName === FORM_ENTRY_TYPE_NAME
						? context
						: (context as any).Form;
			}
		}

		return value;
	}
}
